// Documentation: web-4d-theme/docs/Polyfills.md

import('@doeixd/scoped-focusgroup-polyfill');

if (!('commandFor' in HTMLButtonElement.prototype)) {
	import('invokers-polyfill/fn').then(({ apply }) => apply());
}

if (!('closedBy' in HTMLDialogElement.prototype)) {
	import('dialog-closedby-polyfill');
}

if (!('popover' in HTMLElement.prototype)) {
	import('@oddbird/popover-polyfill/fn').then(({ apply }) => apply());
}

if (!(window.CSS && CSS.supports('top', 'anchor(--test bottom)'))) {
	import('@oddbird/css-anchor-positioning');
}

if (!(window.CSS && CSS.supports('selector(:has(*))'))) {
	import('css-has-pseudo/browser').then(({ default: cssHasPseudo }) => cssHasPseudo(document));
}
